module.exports = __webpack_public_path__ + "img/icon.0f5aaadc.png";